import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import "./assets/styles/_index.scss"
const { ContentModule } = require("@starberry/gatsby-theme-utils/Modules/ContentModule")
const { CTALink } = require("@starberry/gatsby-theme-utils/Modules/CTALinkModule")

const FindSolution = ({ data }) => {
    return (
        <section className="find-solution-wrapper">
            <Container>
                <Row>
                    <Col lg={9}>
                        {data?.services_intro && <ContentModule Content={data.services_intro?.data?.services_intro} />}
                        {data?.cta_link && <CTALink class="button button-primary" link={data.cta_link} title={data.cta_title} target_window={data.cta_link.target_window} />}
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="find-solution-grid-wrapper">
                            {data?.add && data?.add?.length > 0 && data?.add.map((item, index) => (
                                <div className={`find-solution-card ${index === 0 ? "first-arrow" : index === 1 ? "second-arrow" : "third-arrow"}`}>
                                    <div className="find-solution-number-circle d-flex justify-content-center"><span>{index+1}</span></div>
                                    <div className="find-solution-title">{item.title}</div>
                                    <div className="find-solution-desc">{item?.content && <ContentModule Content={item.content?.data?.content} />}</div>
                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default FindSolution